/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { VisitDtoModel, VisitDtoModelType } from "./VisitDtoModel"
import { VisitDtoModelSelector } from "./VisitDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  node: VisitDtoModelType;
}

/**
 * VisitDtoEdgeBase
 * auto generated base class for the model VisitDtoEdgeModel.
 */
export const VisitDtoEdgeModelBase = withTypedRefs<Refs>()(ModelBase
  .named('VisitDtoEdge')
  .props({
    __typename: types.optional(types.literal("VisitDtoEdge"), "VisitDtoEdge"),
    cursor: types.union(types.undefined, types.string),
    node: types.union(types.undefined, MSTGQLRef(types.late((): any => VisitDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class VisitDtoEdgeModelSelector extends QueryBuilder {
  get cursor() { return this.__attr(`cursor`) }
  node(builder: string | VisitDtoModelSelector | ((selector: VisitDtoModelSelector) => VisitDtoModelSelector) | undefined) { return this.__child(`node`, VisitDtoModelSelector, builder) }
}
export function selectFromVisitDtoEdge() {
  return new VisitDtoEdgeModelSelector()
}

export const visitDtoEdgeModelPrimitives = selectFromVisitDtoEdge().cursor
